import React, { Component, Fragment } from 'react';

import { Link } from 'react-router-dom';

import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

import moment from 'moment';
import 'moment/locale/pt-br';

import ActionButton from '../ActionButton';

import { StyledRadioTemplate, StyledDateRangePicker } from './style/StyledDateRangePicker';

const optionsTemplate = ['Relatório Simples', 'Relatório Completo'];

export default class ListLinetable extends Component {
	constructor(props) {
		super(props);

		const {
			element,
		} = this.props;

		this.state = {
			startDate: element.start_date_and_end_date.startDate,
			endDate: element.start_date_and_end_date.endDate,
			template: element.template,
		};
	}

	getDate = (key) => {
		let {
			startDate,
			endDate,
		} = this.state;

		startDate = startDate === '' ? '(sem data)' : moment(startDate).format('DD/MM/YYYY');
		endDate = endDate === '' ? '(sem data)' : moment(endDate).format('DD/MM/YYYY');

		return (
			<td key={key.id}>
				{`${startDate} a ${endDate}`}
			</td>
		);
	};

	changeStateFocus = focusedInput => this.setState({
		focusedInput,
	});

	getDateRangePicker = (key) => {
		const {
			startDate,
			endDate,
			focusedInput,
		} = this.state;

		return (
			<td key={key.id}>
				<StyledDateRangePicker>
					<DateRangePicker
						width="660px"
						startDate={startDate}
						isOutsideRange={() => false}
						startDateId={`start-${key.id}`}
						endDate={endDate}
						endDateId={`end-${key.id}`}
						// eslint-disable-next-line no-shadow
						onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
						focusedInput={focusedInput}
						// eslint-disable-next-line react/jsx-no-bind
						onFocusChange={this.changeStateFocus.bind(focusedInput)}
						startDatePlaceholderText={startDate === '' ? 'data início' : moment(startDate).format('DD/MM/YYYY')}
						endDatePlaceholderText={endDate === '' ? 'data fim' : moment(endDate).format('DD/MM/YYYY')}
					/>
				</StyledDateRangePicker>
			</td>
		);
	};

	changeRadioTemplate = (e) => {
		this.setState({
			template: e.target.value,
		});
	};

	chooseTemplate = (key) => {
		const { template } = this.state;

		return (
			<td key={key.id}>
				<StyledRadioTemplate>
					<div className="radio">
						<input
							id="radio-1"
							name="radio"
							type="radio"
							value="1"
							onChange={e => this.changeRadioTemplate(e)}
							checked={parseInt(template, 0) === 1 ? true : null} 
						/>
						<label htmlFor="radio-1" className="radio-label m-0 mb-2">Simples</label>
					</div>

					<div className="radio">
						<input
							id="radio-2"
							name="radio"
							type="radio"
							value="2"
							onChange={e => this.changeRadioTemplate(e)}
							checked={parseInt(template, 0) === 2 ? true : null} 
						/>
						<label htmlFor="radio-2" className="radio-label m-0">Completo</label>
					</div>
				</StyledRadioTemplate>
			</td>
		);
	};

	renderActions = (element, key) => {
		const { funcUpdate, funcEdit } = this.props;

		const { startDate, endDate, template } = this.state;

		const url = `${window.location.href}/${element.id}`;

		if (key.col === 'edit_or_save') {
			if (element.edit) {
				return (
					<ActionButton
						key={`${element.id}${element.edit_or_save.action}`}
						id={element.id}
						base_url={url}
						name={element.edit_or_save.name}
						action={element.edit_or_save.action}
						func={funcUpdate}
						params={{ startDate, endDate, template }}
					/>
				);
			}

			return (
				<ActionButton
					key={`${element.id}${element.edit_or_save.action}`}
					id={element.id}
					name={element.edit_or_save.name}
					action={element.edit_or_save.action}
					func={funcEdit}
				/>
			);
		}

		if (key.col === 'view') {
			return (
				<Link
					key={`link-${element.id}`}
					to={{
						pathname: `${element.view.link}/${element.id}`,
						action: 'viewReport',
					}}
				>
					<ActionButton
						key={`${element.id}${element.view.action}`}
						id={element.id}
						base_url={url}
						name={element.view.name}
						action={element.view.action}
					/>
				</Link>
			);
		}

		return null;
	};

	buildCellsLine() {
		const {
			element,
			keys,
		} = this.props;

		const {
			template,
		} = this.state;

		return keys.map((key) => {
			if (!(key.col === 'view' || key.col === 'edit_or_save')) {
				if (key.col === 'start_date_and_end_date') {
					if (element.edit) {
						return this.getDateRangePicker(key);
					}

					return this.getDate(key);
				}

				if (key.col === 'template_name') {
					if (element.edit) {
						return this.chooseTemplate(key);
					}

					return (
						<td>
							{template ? optionsTemplate[template - 1] : element[key.col]}
						</td>
					);
				}

				return (
					<td key={key.id}>
						{element[key.col]}
					</td>
				);
			}

			return null;
		});
	}

	buildActions() {
		const {
			element,
			keys,
		} = this.props;

		return keys.map((key) => {
			if (key.col === 'view' || key.col === 'edit_or_save') {
				return (
					this.renderActions(element, key)
				);
			}

			return null;
		});
	}

	render() {
		const {
			element,
		} = this.props;

		return (
			<Fragment>
				<tr key={element.id}>
					{this.buildCellsLine()}
					<td className="d-flex justify-content-end">
						{this.buildActions()}
					</td>
				</tr>
			</Fragment>
		);
	}
}
